import MultipleWiresPage from "components/pages/MultipleWiresPage";

/**
 * @name CaptureSingleWireDefaultWiresMenuOpen
 * @returns {React.Component}
 * @description 
 */
export default function CaptureMultipleWireDefault(props) {
    return <MultipleWiresPage />;
}